import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchPatientRewards = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams();
  if (trialId) params.append("trial_id", trialId);

  const response = await axios.get(
    `${__API_URL__}/api/appiell/dashboard/patient/${patientId}/rewards/?${params.toString()}`,
    {
      headers: { Authorization: `Token ${token}` },
    }
  );
  return response.data;
};

const useGetPatientRewards = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient-rewards", patientId, trialId],
    queryFn: () => fetchPatientRewards({ patientId, trialId }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetPatientRewards;
